export const EspoClientSymbol = Symbol();

export class EspoClient {
    baseUri = '';
    apiKey = '';
    options = {};
    urlPath = '';
    isHttps = false;

    constructor(baseUri, apiKey, options) {
        this.baseUri = baseUri;
        this.apiKey = apiKey;

        if (this.baseUri.substring(-1) === '/') {
            this.baseUri = this.baseUri.substring(0, this.baseUri.length - 1);
        }

        this.options = options ?? {};

        this.isHttps = this.baseUri.toLowerCase().indexOf('https') === 0;
    }

    async request(action, method, data) {
        method = method || 'GET';

        let url = action.includes('http') ? action : this.buildUrl(action);

        const headers = new Headers();

        if (this.apiKey) {
            headers.append('X-Api-Key', this.apiKey);
        }
        else {
            throw new Error('Api-Key is not set.');
        }

        let payload = null;

        if (data) {
            if (method === 'GET') {
                url += '?' + new URLSearchParams({ searchParams: JSON.stringify(data) }).toString();
            }
            else {
                payload = JSON.stringify(data);

                headers.append('Content-Type', 'application/json');
            }
        }

        const response = await fetch(url, {
            method: method,
            headers: headers,
            body: payload,
        });

        if (response.status >= 400 && response.headers.has('x-status-reason')) {
            throw new Error(response.headers.get('x-status-reason') ?? response.statusText);
        }

        if (response.headers.get('Content-Type')?.startsWith('image')) {
            return response.blob();
        }

        const text = await response.text();
        return text.length ? JSON.parse(text) : JSON.parse('');
    }

    buildUrl(action) {
        return this.baseUri + this.urlPath + action;
    }

    async get(url, params) {
        return this.request(url, "GET", params);
    }

    async post(url, payload) {
        return this.request(url, "POST", payload);
    }

    async delete(url) {
        return this.request(url, "DELETE");
    }

    async patch(url, payload) {
        return this.request(url, "PATCH", payload);
    }

    async put(url, payload) {
        return this.request(url, "PUT", payload);
    }
}
